import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { ListMeta } from '../types/api';

/**
 * How many rows a list endpoint has for some filters — the number on a stat tile. Asks for one row and reads
 * meta.total, so the tile and the filtered table can never disagree.
 */
export function useCount(path: string, params: Record<string, unknown> = {}, enabled = true) {
  const q = useQuery({
    queryKey: [path, 'count', params],
    queryFn: async () => ((await api.get<unknown[]>(path, { ...params, page: 1, perPage: 1 })).meta as ListMeta | undefined)?.total ?? 0,
    enabled,
  });
  return q.data;
}
